const ConstructionReport = {

    "construction_project": "Construction Project",
    "stage": "Stage",
    "from_date": "From Date",
    "to_date": "To Date",
    "generate": "Generate",
    "success": "Generated Successfully",
    "preview": "Preview",
    "download": "Download",
    "construction_report": "Construction Report",
    "error_construction_project": "Select Construction Project",
    "error_filter_required": "Select Stage or From Date / To Date",
    "table_project_name": "PROJECT",
    "table_report_type": "REPORT TYPE",
    "table_generated_d&t": "GENERATED DATE",
    "select_project_to_view_history": "Select a construction project to view generated reports",

}

export default ConstructionReport;
